import Dialog from "dialog";
import template from "../html/dialog-config-temperature.html";
import css from "../css/dialog-config-temperature.css";

class ConfigTemperatureDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-temperature", ConfigTemperatureDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.temperatureSensor.id;
		this.textboxDeviceStatus.value = devices.temperatureSensor.status;
		this.textboxValue.value = devices.temperatureSensor.value;
	}
	buttonClose_click(event) {
		this.close();
	}
	close() {
		super.close();
	}
}

ConfigTemperatureDialog.constructor();

export default ConfigTemperatureDialog;